import * as qs from 'qs';
import type { FetchListOptions } from '../types/types';

export const defaultFetchListOptions: FetchListOptions = {
  page: 1,
  itemsPerPage: 10,
  sortBy: ['id'],
  sortDesc: [true],
  groupBy: [],
  groupDesc: [],
  multiSort: false,
  mustSort: false,
  searchString: '',
  filters: {},
  force: false,
};
export default function useQuery() {
  function makeSortBy(sortBy: string[]): string {
    if (!sortBy || sortBy[0] === '') return 'name';
    if (sortBy[0] === 'uid') return 'id';

    return sortBy[0];
  }

  function makeQuery(options: FetchListOptions): string {
    const queryData = {
      q: options.searchString,
      pageNumber: options.page,
      pageSize: options.itemsPerPage,
      sortBy: makeSortBy(options.sortBy || []),
      sortOrder: options.sortDesc && options.sortDesc[0] === true ? 'desc' : 'asc',
      filters: options.filters,
    };

    return qs.stringify(queryData);
  }

  /**
   * TODO: is a temp. solution. Later implementation will be using customer-mgmt types.
   */
  function makeQueryByObject(options: Record<string, unknown>): string {
    return qs.stringify(options);
  }

  return {
    makeQuery,
    makeQueryByObject,
  };
}
